import React, { useState, useEffect, useCallback } from 'react';
import { RouteComponentProps } from '@reach/router';

import { logEvent } from 'utils/amplitude';

import PaymentDetailsStep from './PaymentDetailsStep/PaymentDetailsStep';
import SubmitPaymentStep from './SubmitPaymentStep/SubmitPaymentStep';
import { PaymentDetailsValues } from './helperTypes';
import { PaymentMethodFormValues } from '../shared/PaymentMethodForm';

type Props = RouteComponentProps<{ slug: string }>;

const PublicPaymentPage: React.FC<Props> = () => {
  const [paymentDetails, setPaymentDetails] = useState<PaymentDetailsValues>(null);
  const [paymentMethodDetails, setPaymentMethodDetails] = useState<PaymentMethodFormValues>(null);
  const [isOnFirstStep, setOnFirstStep] = useState(true);

  useEffect(() => {
    logEvent('visit payment site', {
      'practice id': window.el8Globals.PRACTICE_ID,
    });
  }, []);

  const handleConfirmPaymentDetails = useCallback((values: PaymentDetailsValues) => {
    setPaymentDetails(values);
    setOnFirstStep(false);
  }, []);

  const handleEditPaymentDetails = useCallback((values: PaymentMethodFormValues) => {
    setPaymentMethodDetails(values);
    setOnFirstStep(true);
  }, []);

  if (isOnFirstStep) {
    return (
      <PaymentDetailsStep
        initialValues={paymentDetails}
        onConfirmPaymentDetails={handleConfirmPaymentDetails}
      />
    );
  }

  return (
    <SubmitPaymentStep
      initialValues={paymentMethodDetails}
      paymentDetails={paymentDetails}
      onEditPaymentDetails={handleEditPaymentDetails}
    />
  );
};

export default PublicPaymentPage;
